module.exports = __webpack_public_path__ + "pic/blacklist.c4797d2e.jpg";